"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var Portal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Portal, _React$PureComponent);

  function Portal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Portal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Portal).call(this, props));
    _this.node = document.createElement('div');
    document.body.appendChild(_this.node);
    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.node);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _reactDom.createPortal)(_react.default.createElement("div", this.props), this.node);
    }
  }]);
  return Portal;
}(_react.default.PureComponent);

exports.default = Portal;